import styled from 'styled-components';

export const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  overflow: visible;
  -webkit-appearance: none;
  padding: 0;

  svg {
    width: 27px;
    height: 25px;

    &.active > path {
      fill: ${props => props.theme.card.favouriteButtonColor};
    }

    path {
      fill: grey;
      stroke: white;
    }
  }
`;
